import { computed, ComputedRef, Ref, ref } from '@vue/composition-api'
import { intersection as intersectionUtil } from 'vtils'

export interface UseSetResult<T> {
  size: ComputedRef<number>
  add: (...value: T[]) => void
  delete: (...value: T[]) => void
  toggle: (...value: T[]) => void
  intersect: (...value: T[]) => void
  has: (...value: T[]) => boolean
  clear: () => void
  toArray: () => T[]
}

export function useSet<T>(initialValue: T[]): UseSetResult<T> {
  const data = ref(initialValue) as Ref<T[]>

  const size = computed(() => data.value.length)

  const add = (...value: T[]) => {
    value.forEach(v => {
      const index = data.value.indexOf(v)
      if (index === -1) {
        data.value.push(v)
      }
    })
  }

  const _delete = (...value: T[]) => {
    value.forEach(v => {
      const index = data.value.indexOf(v)
      if (index !== -1) {
        data.value.splice(index, 1)
      }
    })
  }

  const toggle = (...value: T[]) => {
    value.forEach(v => {
      const index = data.value.indexOf(v)
      if (index !== -1) {
        data.value.splice(index, 1)
      } else {
        data.value.push(v)
      }
    })
  }

  const intersect = (...value: T[]) => {
    data.value = intersectionUtil(data.value, value)
  }

  const has = (...value: T[]) => {
    return value.every(v => data.value.includes(v))
  }

  const clear = () => {
    data.value = []
  }

  const toArray = () => {
    return data.value.slice()
  }

  return {
    size,
    add,
    delete: _delete,
    toggle,
    intersect,
    has,
    clear,
    toArray,
  }
}
